import React, { useState } from "react";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import axios from "axios";
import AddAccount from "./addAccount";
import Sidebar from "../../../Sidebar";
import "./searchAddPage.css";

const SearchAddPage = () => {
  const [formData, setFormData] = useState({
    account: "",
    postalCode: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  /* ================= SEARCH ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};

    if (!formData.account.trim()) {
      validationErrors.account = "Account name is required";
    }

    if (!formData.postalCode.trim()) {
      validationErrors.postalCode = "Postal code is required";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://hms.backend.hiragroupcloud.com/api/account/searchAccount/",
        formData
      );

      setAccountDetails(response.data.account);
      setShowAccountDetails(true);
    } catch (error) {
      console.error("Error submitting form:", error);

      setErrors({
        submit: "An error occurred. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="search-page">

      {/* ================= HEADER ================= */}

      <Header />

      {/* ================= NAVBAR ================= */}

      <Navvbar />

      {/* ================= MAIN CONTAINER ================= */}

      <div className="container-fluid main-container">

        <div className="row main-row">

          {/* =====================================================
              SIDEBAR
          ===================================================== */}

          <div className="col-3 col-md-3 col-lg-2 sidebar-container">

            <div className="sidebar-inner">

              <Sidebar />

            </div>

          </div>

          {/* =====================================================
              MAIN CONTENT
          ===================================================== */}

          <div className="col-9 col-md-9 col-lg-10 main-content">

            {/* ================= MAIN TITLE ================= */}

            <h1 className="main-title">
              Add Account
            </h1>

            {/* ================= ACCOUNT SEARCH TITLE ================= */}

            <h3 className="sub-title">
              Account Search
            </h3>

            {/* =================================================
                SEARCH SECTION
            ================================================= */}

            <div className="search-section">

              <div className="search-form-container">

                {/* ================= ZIP / POSTAL ================= */}

                <div className="search-form-group">

                  <div className="search-input-row">

                    <label className="search-form-label">
                      Zip / Postal Code{" "}
                      <span className="required-star">
                        *
                      </span>
                    </label>

                    <div className="search-input-wrapper">

                      <input
                        type="text"
                        name="postalCode"
                        className="search-form-control"
                        value={formData.postalCode}
                        onChange={handleChange}
                        placeholder="Enter postal code"
                      />

                      {errors.postalCode && (
                        <span className="error-message">
                          {errors.postalCode}
                        </span>
                      )}

                    </div>

                  </div>

                </div>

                {/* ================= ACCOUNT NAME ================= */}

                <div className="search-form-group">

                  <div className="search-input-row">

                    <label className="search-form-label">
                      Account Name{" "}
                      <span className="required-star">
                        *
                      </span>
                    </label>

                    <div className="search-input-wrapper">

                      <input
                        type="text"
                        name="account"
                        className="search-form-control"
                        value={formData.account}
                        onChange={handleChange}
                        placeholder="Enter account name"
                      />

                      {errors.account && (
                        <span className="error-message">
                          {errors.account}
                        </span>
                      )}

                    </div>

                  </div>

                </div>

                {/* ================= SEARCH BUTTON ================= */}

                <div className="search-button-container">

                  <button
                    type="button"
                    className="btn btn-primary search-button"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? "Wait..." : "Search"}
                  </button>

                </div>

              </div>

            </div>

            {/* ================= SPACE ================= */}

            <br />

            {/* ================= ADD ACCOUNT TEXT ================= */}

            <div className="text-section">

              <p className="add-account-text">
                Don't see the account you are looking for? Add it.
              </p>

            </div>

            {/* =================================================
                ADD ACCOUNT
            ================================================= */}

            <div className="add-account-form-wrapper">

              <AddAccount
                formData={formData}
                handleChange={handleChange}
              />

            </div>

            {/* ================= ERRORS ================= */}

            {errors.submit && (
              <p className="error-message">
                {errors.submit}
              </p>
            )}

            {errors.fetch && (
              <p className="error-message">
                {errors.fetch}
              </p>
            )}

            {/* ================= SUCCESS ================= */}

            {showAccountDetails && (
              <div className="alert alert-success mt-3">
                Account found successfully!
              </div>
            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default SearchAddPage;